var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavInterests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 811445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1068 22.8389C9.94437 22.8389 9.94437 22.8389 9.78193 22.8389C6.85805 22.8389 3.93416 22.8389 1.01027 22.8389C0.360521 22.8389 0.0356445 22.514 0.0356445 21.8642C0.0356445 19.2652 0.685397 16.8286 2.14734 14.5545C3.28441 12.9301 4.58391 11.7931 6.20829 10.9809C6.20829 10.9809 6.37073 10.9809 6.37073 10.8184C4.58391 9.68137 3.77172 8.05699 3.60928 5.94529C3.60928 4.32091 4.25904 2.85896 5.3961 1.7219C7.83267 -0.552236 11.5688 -0.389798 13.6804 2.04677C15.9546 4.64578 15.4673 8.70674 12.3809 10.8184C13.1931 11.3057 14.0053 11.7931 14.6551 12.2804C12.3809 12.9301 10.5941 14.2296 9.61949 16.3413C8.64487 18.6155 8.8073 20.7272 10.1068 22.8389Z",
    fill: "url(#paint0_linear_698_4752)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 811439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1417 25.1131C18.9096 25.1131 21.9641 22.0586 21.9641 18.2907C21.9641 14.5228 18.9096 11.4683 15.1417 11.4683C11.3738 11.4683 8.31934 14.5228 8.31934 18.2907C8.31934 22.0586 11.3738 25.1131 15.1417 25.1131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1417 25.1131C18.9096 25.1131 21.9641 22.0586 21.9641 18.2907C21.9641 14.5228 18.9096 11.4683 15.1417 11.4683C11.3738 11.4683 8.31934 14.5228 8.31934 18.2907C8.31934 22.0586 11.3738 25.1131 15.1417 25.1131Z",
    fill: "url(#paint1_linear_698_4752)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1417 25.1131C18.9096 25.1131 21.9641 22.0586 21.9641 18.2907C21.9641 14.5228 18.9096 11.4683 15.1417 11.4683C11.3738 11.4683 8.31934 14.5228 8.31934 18.2907C8.31934 22.0586 11.3738 25.1131 15.1417 25.1131Z",
    fill: "url(#paint2_linear_698_4752)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.3062 16.4215C15.5214 16.2213 15.6648 16.0879 15.88 15.8877C17.0994 14.9536 18.7491 15.3539 19.3229 16.6884C19.6098 17.3557 19.4664 18.0229 19.1794 18.6235C18.8925 19.224 18.4622 19.6911 18.0318 20.1581C17.2428 20.9588 16.3821 21.6261 15.4496 22.2934C15.3779 22.2934 15.3062 22.3601 15.2344 22.2934C13.9434 21.4259 12.7957 20.5585 11.8633 19.3574C11.4329 18.8236 11.146 18.2231 11.146 17.4891C11.146 16.6217 11.5764 15.9544 12.4371 15.6208C13.2261 15.2205 14.0151 15.4206 14.7324 15.8877C14.9475 16.0212 15.091 16.2213 15.3062 16.4215Z",
    fill: "url(#paint3_linear_698_4752)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_698_4752",
    x1: 0.0356445,
    y1: 11.5112,
    x2: 15.1814,
    y2: 11.5112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4237C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2C6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_698_4752",
    x1: 8.30013,
    y1: 18.216,
    x2: 21.996,
    y2: 18.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD973"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_698_4752",
    x1: 8.30013,
    y1: 18.216,
    x2: 21.996,
    y2: 18.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_698_4752",
    x1: 11.7106,
    y1: 19.9596,
    x2: 18.9342,
    y2: 16.0695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A52144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED2651"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavInterests);
export default __webpack_public_path__ + "static/media/sidenav_interests.29648be9a6d35723dd93b65dab180819.svg";
export { ForwardRef as ReactComponent };